<div class="inspect-panel-root" style="width: 560px; background-color: var(--np-white-color);">
  <div class="panel-title">{{ containerName }}</div>
  <div class="logo-placeholder" *ngIf="context !== 'containerCatalog'">
    <img *ngIf="logoLink || container?.logoLink" [src]="logoLink || container?.logoLink" alt="Logo" class="title-logo" />
  </div>

  <ng-container [ngSwitch]="context">
    <np-inspect-container-details-context
      *ngSwitchCase="'containerDetails'"
      [container]="container"
      [containerType]="containerType"
      (containerSaved)="containerSaved.emit($event)"
      (containerDeleted)="containerDeleted.emit()"
      (containerDuplicated)="containerDuplicated.emit($event)">
    </np-inspect-container-details-context>

    <np-inspect-container-details-context
      *ngSwitchCase="'exportContainerDetails'"
      [container]="container"
      [containerType]="containerType"
      (containerSaved)="containerSaved.emit($event)"
      (containerDeleted)="containerDeleted.emit()"
      (containerDuplicated)="containerDuplicated.emit($event)">
    </np-inspect-container-details-context>

    <np-inspect-container-catalog
      *ngSwitchCase="'containerCatalog'"
      [container]="$any(container)"
      [catalogId]="catalogId"
      (containerSaved)="containerSaved.emit($event)">
    </np-inspect-container-catalog>
  </ng-container>
</div>
